import actions from './actions';

const initState = {
    isSidebarOpen  : true,
    isSettingsOpen : false,
    isRightbarOpen : false
};

export default function layout(state = initState, action) {
    switch (action.type) {
        case actions.TOGGLE_SIDEBAR:
            return {
                ...state,
                isSidebarOpen : !state.isSidebarOpen
            };
        case actions.TOGGLE_SETTINGS:
            return {
                ...state,
                isSettingsOpen: !state.isSettingsOpen
            };
        case actions.TOGGLE_RIGHTBAR:
            return {
                ...state,
                isRightbarOpen: !state.isRightbarOpen
            };
        default:
            return state;
    }
}
